// extracted by mini-css-extract-plugin
export default {"ListItemTitle_0":"IssuePullRequestTitle-module__ListItemTitle_0--UQ3gh"};